import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { AppConfigModel } from '@libs/cms/models';
import { NavItemModel } from '@libs/shared/models';
import { NavLinkDirective } from '@libs/shared/ui';
import { DateTime } from 'luxon';

import { ImageComponent } from '../../data-display/image';

@Component({
  selector: 'ui-lekkerland-footer-slot',
  templateUrl: './lekkerland-footer-slot.component.html',
  styleUrls: ['./lekkerland-footer-slot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, NavLinkDirective],
})
export class LekkerlandFooterSlotComponent {
  public readonly config: InputSignal<AppConfigModel> = input.required();

  public readonly legalLinks: Signal<NavItemModel[]> = computed(
    () => this.config().navigation.Legal?.children ?? [],
  );

  public readonly copyrightText: Signal<string> = computed(
    () => `© ${DateTime.now().year} ${this.config().company.copyright}`,
  );
}
